import { bizGet } from '@/shared/api/bizClient';

import type { RevenueLeak } from './types';

interface ListEnvelope<T> {
  items: T[];
}

export async function listRevenueLeaks(branchId: string): Promise<RevenueLeak[]> {
  const response = await bizGet<ListEnvelope<RevenueLeak>>('/biz/revenue/leaks', {
    params: { branchId },
  });
  return response.items;
}
